interface ToggleProps {
  label?: string
  checked: boolean
  onChange: (checked: boolean) => void
  /** Disables interaction (e.g. featuring a review that isn't APPROVED yet). */
  disabled?: boolean
  /** Native title tooltip — mainly useful alongside `disabled` to explain why. */
  title?: string
}

export const Toggle = ({ label, checked, onChange, disabled = false, title }: ToggleProps) => {
  return (
    <div className="flex items-center gap-3" title={title}>
      {label &&
        <label className="block text-[14px] font-[600] text-foreground ">{label}</label>
      }
      {/* The button is the hit area, the inner span the visible 33×20 track. Below lg the
          button grows to a 40px tap target (the responsive audit's touch minimum) without
          changing how the switch looks. */}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={`inline-flex items-center justify-center min-h-10 min-w-10 lg:min-h-0 lg:min-w-0 ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        <span
          className={`relative block w-[33.2px] h-[20px] rounded-full transition-colors ${
            checked ? 'bg-[#28282A]' : 'bg-gray-300'
          }`}
        >
          <span
            className={`absolute top-[1px] -left-1 w-[17.42px] h-[17.42px] bg-card rounded-full outline-none transition-transform ${
              checked ? 'translate-x-5' : 'translate-x-1'
            }`}
          />
        </span>
      </button>
    </div>
  )
}